import React from 'react'

import { SearchableDropdownOption } from 'libs/dropdown-search'

interface TeamMemberLike {
  id: number
  name?: string | null
  email?: string | null
  member_id?: string | null
}

export interface TeamMemberDropdownOption extends SearchableDropdownOption {
  key: number
  value: number
  text: React.ReactNode
  content: React.ReactNode
  searchableText: string
}

/**
 * Build a Semantic UI Dropdown option for a team member. Renders the
 * primary identifier (name → email → external ID) on top and a muted
 * `email · external ID` line underneath in the open menu. `text` joins
 * primary and secondary so the closed dropdown trigger displays
 * `name · email · external ID`; `searchableText` carries all three
 * fields for `searchDropdownOptions` to match against.
 */
export function buildTeamMemberDropdownOption(member: TeamMemberLike): TeamMemberDropdownOption {
  const primary = member.name || member.email || member.member_id || ''
  const secondary = [member.email, member.member_id].filter((v) => v && v !== primary).join(' · ')
  const searchableText = [member.name, member.email, member.member_id]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

  return {
    key: member.id,
    value: member.id,
    text: (
      <>
        {primary}
        {secondary && <span className="text-grey ml-1">· {secondary}</span>}
      </>
    ),
    searchableText,
    content: (
      <div>
        <div>{primary}</div>
        {secondary && <div className="text-grey">{secondary}</div>}
      </div>
    ),
  }
}



// WEBPACK FOOTER //
// ./src/libs/team-member-dropdown-option/index.tsx